import { serverUrl, getDefaultHeaders } from 'services/authService';
import { ConnectorGroup } from 'models/ConnectorGroup';

const getConnectorGroup = async (id: number, accessToken: string) => {
  const response = await fetch(`${serverUrl}/connector_group/${id}`, {
    headers: getDefaultHeaders(accessToken),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch connector group');
  }

  return response.json();
};

const fetchMonthlySummary = async (id: number, accessToken: string) => {
  const response = await fetch(`${serverUrl}/connector_group/${id}/monthly_summary`, {
    headers: getDefaultHeaders(accessToken),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch connector group monthly summary');
  }

  return response.json();
};

const fetchWeeklySummary = async (id: number, accessToken: string) => {
  const response = await fetch(`${serverUrl}/connector_group/${id}/weekly_summary`, {
    headers: getDefaultHeaders(accessToken),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch connector group weekly summary');
  }

  return response.json();
};

const createConnectorGroup = async (data: ConnectorGroup, accessToken: string) => {
  const response = await fetch(`${serverUrl}/connector_group`, {
    method: 'POST',
    headers: getDefaultHeaders(accessToken),
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Failed to create connector group');
  }

  return response.json();
};

const updateConnectorGroup = async (id: number, data: ConnectorGroup, accessToken: string) => {
  const response = await fetch(`${serverUrl}/connector_group/${id}`, {
    method: 'PUT',
    headers: getDefaultHeaders(accessToken),
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Failed to update connector group');
  }

  return response.json();
};

const deleteConnectorGroup = async (id: number, accessToken: string) => {
  const response = await fetch(`${serverUrl}/connector_group/${id}`, {
    method: 'DELETE',
    headers: getDefaultHeaders(accessToken),
  });

  if (!response.ok) {
    let errorMessage = 'Failed to delete connector group';
    try {
      const errorData = await response.json();
      errorMessage = errorData.message ?? errorMessage;
    } catch {
      // non-JSON error response
    }
    throw new Error(errorMessage);
  }

  const text = await response.text();
  return text ? JSON.parse(text) : { message: 'Connector group deleted!' };
};

export {
  getConnectorGroup,
  fetchMonthlySummary,
  fetchWeeklySummary,
  createConnectorGroup,
  updateConnectorGroup,
  deleteConnectorGroup,
};
